import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useEffect } from 'react';
import { NotificationOutline } from '../../../icons/icons';
import { downloadNotification } from '../../../services/systemhub-service';
import { useAppDispatch, useAppSelector } from '../../hooks/store-hooks';
import { setSystemHubNotification } from '../../state/slices/global-slice';

export function SystemHubNotifications() {
    const notification = useAppSelector((x) => x.global.systemHubNotification);
    const dispatch = useAppDispatch();
    const close = () => {
        dispatch(
            setSystemHubNotification({
                notification: {
                    ...notification,
                    showPopup: false
                }
            })
        );
    };

    useEffect(() => {
        downloadNotification();
    }, []);

    if (!notification.showPopup) {
        return null;
    }

    return (
        <Dialog
            onClose={close}
            title={
                <div className="d-flex gap-2">
                    <SvgIcon icon={NotificationOutline} size="large" /> Notification
                </div>
            }>
            <div>
                <div>An important Flight Explorer System Hub message has been posted.</div>
                {notification.text && notification.text.split('\r\n').map((line, i) => <div key={i}> {line}</div>)}
            </div>
            <DialogActionsBar>
                <Button themeColor={'primary'} onClick={close}>
                    Close
                </Button>
            </DialogActionsBar>
        </Dialog>
    );
}
